import React, {useContext, useState, useEffect} from 'react';

import Nav from './Nav'

import {appContext} from '../contexts'

const Header = () => {
    const context = useContext(appContext)
    const [isActive, setIsActive] = useState(false)
    const [headerClasses, setHeaderClasses] = useState("")

    const toggleActive = async () => {
        setIsActive(!isActive)
    }

    useEffect(()=>{
        if(isActive){
            setHeaderClasses(`${context.mode} active`)
        }else{
            setHeaderClasses(`${context.mode}`)
        }
    }, [isActive, context.mode])
    

    return ( 
        <header className={`${headerClasses}`} ref={context.headerRef}>
            <h1>DeLesslin George-Warren</h1>
            <Nav handleClick={toggleActive}/>
        </header>
     );
}
 
export default Header;